import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    getCartLine,
    RemoveCartLineApiParameter,
    removeCartLineWithResult as removeCartLineApi,
} from "@insite/client-framework/Services/CartService";


import { sendRemoveFromCartEvent } from "@insite/client-framework/OdpEvents/UpdateCartEvents";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";

import { replaceInChain } from "@insite/client-framework/HandlerCreator";

import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SendRemoveFromCartEvent } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";

type Parameter = {
    cartLineId: string;
};

type Props = {
    apiParameter: RemoveCartLineApiParameter;
};
type HandlerType = Handler<Parameter, Props>;


export const SendRemoveFromCartEventCustom: HandlerType = async props => {
 
    const state= props.getState()
    const cartId =  state.pages.checkoutShipping.cartId;
        const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
     const line = cart?.cartLines?.find(
         line => line.id === props.parameter.cartLineId
     );
     let cartLineModel;

     if (line) {
         cartLineModel = line.isActive
             ? await getCartLine({
                   cartId: API_URL_CURRENT_FRAGMENT,
                   cartLineId: props.parameter.cartLineId,
               })
             : line;
     
         sendRemoveFromCartEvent(
             {
                 productId: cartLineModel.productId!,
                 qtyOrdered: cartLineModel.qtyOrdered!,
             },
             props.getState(),
         );
     }
};
replaceInChain(chain, SendRemoveFromCartEvent, SendRemoveFromCartEventCustom);